module.exports = __webpack_public_path__ + "static/media/QH.c439a881.svg";